import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiOpportunity from '../../Api/ApiOpportunity';
import ToastMsg from '../../Components/ToastMsg';
import { creators as OpportunityActions } from '../../Reducers/Reporting/Opportunity';

export function* getOpportunitySummary({ payload }) {
  try {
    const response = yield call(
      ApiOpportunity.getSummary,
      payload.selectedYears,
    );

    if (response.status === 200) {
      yield put(OpportunityActions.opportunitySuccess({ summaryData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Opportunity Summary',
            text: response.message,
          },
        },
      );
      yield put(OpportunityActions.opportunityFailure(response.message));
    }
  } catch (e) {
    yield put(OpportunityActions.opportunityFailure(e));
  }
}

export function* getOpportunityDetail({ payload }) {
  try {
    const response = yield call(
      ApiOpportunity.getDetail,
      payload.selectedYears,
    );

    if (response.status === 200) {
      yield put(OpportunityActions.opportunitySuccess({ detailData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Opportunity Detail',
            text: response.message,
          },
        },
      );
      yield put(OpportunityActions.opportunityFailure(response.message));
    }
  } catch (e) {
    yield put(OpportunityActions.opportunityFailure(e));
  }
}
